'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { formatCentsToDollars } from 'ecosystem-marketplace-core/utils/currency';

const CurrencyText = ({
  cents
}) => {
  const dollars = useMemo(() => formatCentsToDollars(cents), [cents]);

  if (dollars % 1) {
    return /*#__PURE__*/_jsx(FormattedCurrency, {
      value: dollars,
      currencyCode: "USD"
    });
  }

  return /*#__PURE__*/_jsx(FormattedCurrency, {
    value: dollars,
    simplifyCurrency: true,
    currencyCode: "USD"
  });
};

CurrencyText.propTypes = {
  cents: PropTypes.number.isRequired
};
export default CurrencyText;